import { defineStore } from 'pinia';
import type { Toast } from '@/types/toastTypes.ts';
import { computed, ref } from 'vue';

export const useHeaderStore = defineStore('header', () => {
  // States
  const _toasts = ref<Toast[]>([]);

  // Getters
  const hasToasts = computed(() => _toasts.value.length > 0);
  const toasts = computed(() => _toasts.value);

  // Actions
  function addToast(toast: Toast): number {
    const nextId = hasToasts.value ? Math.max(..._toasts.value.map((t) => t.id || 0)) + 1 : 0;

    _toasts.value.push({ id: nextId, ...toast });

    return nextId;
  }

  function removeToast(id: number): void {
    const idx = _toasts.value.findIndex((t) => t.id === id);

    if (idx !== -1) {
      _toasts.value.splice(idx, 1);
    }
  }

  function clearToasts(): void {
    _toasts.value = [];
  }

  return {
    hasToasts,
    toasts,
    addToast,
    removeToast,
    clearToasts,
  };
});

export default useHeaderStore;
